var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJumActionareElectromecanicaCuTemporizareLaAnclansareSiLaRevenire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 80,
    viewBox: "0 0 83 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 29.5H75.5V53.5H50.5V29.5Z",
    fill: "black",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 29.5,
    width: 7,
    height: 24,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumActionareElectromecanicaCuTemporizareLaAnclansareSiLaRevenire);
export default __webpack_public_path__ + "static/media/jum_actionare_electromecanica_cu_temporizare_la_anclansare_si_la_revenire.3770be4e8ccbd172c5629fdf1067b895.svg";
export { ForwardRef as ReactComponent };